import OrderHistoryPage from '../../components/orderHistory/OrderHistoryPage';

const OrdersPage = () => {
	return <OrderHistoryPage />;
};

export default OrdersPage;
